import { axiosInstance } from "apis/_axios";

export const signUpApi = (data) => {
  return axiosInstance().post("/user/general/register", data);
};
